<template>
  <section id="wrapper" class="py-10">
    <div class="container mx-auto max-w-4xl px-4">
      <!-- Page Title -->
      <h2 class="text-3xl font-bold text-center mb-10">
        Billing Terms &amp; Conditions
      </h2>

      <!-- Warranty Period -->
      <div class="mb-8">
        <h3 class="headline-section">Warranty Period</h3>
        <p class="privacy-policies-para">
          Most products on
          <a href="https://penpencilbd.com" target="_blank" class="link">
            penpencilbd.com
          </a>
          come with a
          <strong>7-day warranty</strong>
          against manufacturing defects (e.g., faulty pens, missing pages, misprints).
          This warranty does not cover damage due to misuse, mishandling, or normal wear &amp; tear.
        </p>
      </div>

      <!-- Warranty Procedure -->
      <div class="mb-8">
        <h3 class="headline-section">Warranty Procedure</h3>
        <p class="privacy-policies-para">
          To claim a warranty, please keep your purchase receipt or order confirmation.
          Report defective products within 7 days of delivery by emailing
          <a href="mailto:info.penpencilbd@gmail.com" class="link">info.penpencilbd@gmail.com</a>
          with clear photographs and description. We will verify the issue and provide a replacement, repair,
          or store credit if eligible.
        </p>
      </div>

      <!-- Payment Terms -->
      <div class="mb-8">
        <h3 class="headline-section">Terms of Payment</h3>
        <p class="privacy-policies-para">
          50% advance payment is required to confirm an order. The remaining amount should be paid before shipment or delivery as agreed.
        </p>
      </div>

      <!-- Mode of Payment -->
      <div class="mb-8">
        <h3 class="headline-section">Mode of Payment</h3>
        <p class="privacy-policies-para">
          Payments can be made via cash on delivery, bank transfer, mobile banking, credit/debit card, or bKash.
          For cheque payments, the order will be processed after clearance of the cheque.
        </p>
      </div>

      <!-- Cancellation -->
      <div class="mb-8">
        <h3 class="headline-section">Order Change or Cancellation</h3>
        <p class="privacy-policies-para">
          Orders cannot be cancelled once confirmed. Minor changes (e.g., quantity, color, type) can be requested within 24 hours.
          Customized or personalized items cannot be modified or cancelled.
        </p>
      </div>

      <!-- Validity -->
      <div class="mb-8">
        <h3 class="headline-section">Order Validity</h3>
        <p class="privacy-policies-para">
          Orders remain valid for 6 months from the date of confirmation.
        </p>
      </div>

      <!-- Delivery -->
      <div class="mb-8">
        <h3 class="headline-section">Delivery Period</h3>
        <p class="privacy-policies-para">
          Standard delivery is from ready stock. For out-of-stock items, the delivery date will be confirmed after discussion with the customer.
          Delivery timelines may vary due to unforeseen circumstances.
        </p>
      </div>

      <!-- Product Updates -->
      <div class="mb-12">
        <h3 class="headline-section">Product Updates</h3>
        <p class="privacy-policies-para">
          Product designs and packaging may be updated periodically. Minor changes will not affect the functional value or quality of the product.
        </p>
      </div>

      <!-- User Instructions -->
      <h3 class="text-2xl font-semibold text-center mb-6">User Instructions</h3>
      <ul class="list-disc list-inside space-y-2 privacy-policies-para">
        <li>Keep pens, pencils, and markers capped when not in use to prevent drying out.</li>
        <li>Store notebooks, papers, and printed materials in a dry place to avoid moisture damage.</li>
        <li>Handle stationery items gently to prevent breakage or tearing.</li>
        <li>Keep ink-based items away from heat sources or direct sunlight to prevent fading.</li>
        <li>Do not use harsh chemicals on notebooks, journals, or planners as it may damage pages or covers.</li>
        <li>Keep small stationery items out of reach of children to avoid choking hazards.</li>
        <li>Customized or personalized items are non-returnable unless defective upon delivery.</li>
        <li>
          For any concerns or queries, contact us at
          <a href="mailto:info.penpencilbd@gmail.com" class="link">info.penpencilbd@gmail.com</a>.
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup></script>

<style scoped lang="scss">
.headline-section {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
  color: #222;
}

.privacy-policies-para {
  font-size: 1rem;
  line-height: 1.6;
  color: #444;
}

.link {
  color: #f69320;
  font-weight: 600;
  text-decoration: none;
}
.link:hover {
  text-decoration: underline;
}
</style>
